import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {API_BASE_URL} from '../../configs/AppConfig';
import service from "../../auth/FetchInterceptor";
import {SORT_ORDER} from "../../constants/Constants";

export const fetchPublicLinks = createAsyncThunk(
    'explore/fetchPublicLinks',
    async ({page = 1, pageSize = 8, sorter = {}, t}, {rejectWithValue}) => {
        try {
            const queryParams = new URLSearchParams({
                page: page - 1,
                size: pageSize,
            });
            if (sorter.field && sorter.order) {
                const sortOrder = sorter.order === SORT_ORDER.ASCEND ? SORT_ORDER.ASC : SORT_ORDER.DESC;
                queryParams.append(SORT_ORDER.SORT, `${sorter.field},${sortOrder}`);
            }
            return await service.get(`${API_BASE_URL}/api/links/public?${queryParams.toString()}`);
        } catch (error) {
            return rejectWithValue(error.response?.data || t('error.failed.to.load.links'));
        }
    }
);

const exploreSlice = createSlice({
    name: 'explore',
    initialState: {
        data: [],
        loading: false,
        error: null,
        pagination: {
            current: 1,
            pageSize: 8,
            total: 0,
        },
        sorter: {field: null, order: null},
    },
    reducers: {
        setExplorePagination: (state, action) => {
            state.pagination.current = action.payload.current;
            state.pagination.pageSize = action.payload.pageSize;
        },
        setExploreSorter: (state, action) => {
            state.sorter = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPublicLinks.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPublicLinks.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.content;
                state.pagination = {
                    current: action.payload.number + 1,
                    pageSize: action.payload.size,
                    total: action.payload.totalElements,
                };
            })
            .addCase(fetchPublicLinks.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const {setExplorePagination, setExploreSorter} = exploreSlice.actions;
export default exploreSlice.reducer;
